import { Navigate, Route, Routes } from 'react-router-dom';
import Shell from './components/Shell';
import ProtectedRoute from './routes/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import MagicLoginPage from './pages/MagicLoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import ComplaintsPage from './pages/ComplaintsPage';
import UnauthorizedPage from './pages/UnauthorizedPage';

const App = () => {
  return (
    <Routes>
      <Route path="/signin" element={<LoginPage />} />
      <Route path="/magic" element={<MagicLoginPage />} />
      <Route path="/auth/magic-link" element={<MagicLoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route element={<ProtectedRoute />}>
        <Route
          path="/"
          element={
            <Shell>
              <DashboardPage />
            </Shell>
          }
        />
        <Route
          path="/complaints"
          element={
            <Shell>
              <ComplaintsPage />
            </Shell>
          }
        />
      </Route>
      <Route element={<ProtectedRoute requireAdmin />}>
        <Route
          path="/admin"
          element={
            <Shell>
              <AdminPage />
            </Shell>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
